// extracted by mini-css-extract-plugin
export default {"item":"PaymentMethodCardItem_item__qMuLF","disabled":"PaymentMethodCardItem_disabled__LR9WS"};